'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiPuzzleOutline = function TiPuzzleOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.3 18.8v-3c0-3.2-2.6-5.8-5.8-5.8h-1.3c-0.2-3.3-3.2-5.8-7-5.8s-6.9 2.5-7.1 5.8h-1.3c-3.2 0-5.8 2.6-5.8 5.8v3c0 1.6 0.9 3 2.2 3.7-0.6 0.3-1.2 0.8-1.5 1.4-0.5 0.7-0.7 1.5-0.7 2.4v4.5c0 3.2 2.6 5.9 5.8 5.9h4.6c1.6 0 3.1-0.9 3.8-2.2 0 0 0 0.1 0 0.1 0.7 1.3 2.1 2.1 3.7 2.1h4.6c3.2 0 5.8-2.7 5.8-5.9v-4.5c0-1.7-0.8-3.1-2.1-3.8 1.3-0.7 2.1-2.1 2.1-3.7z m-3.3 12c0 1.4-1.1 2.5-2.5 2.5h-4.6c-0.6 0-1.2-0.3-0.6-1.2 0.4-0.5 0.6-1.1 0.6-1.7 0-1.6-1.7-2.9-3.7-2.9s-3.8 1.3-3.8 2.9c0 0.5 0.2 1 0.4 1.4 0.9 1.1 0.3 1.5-0.4 1.5h-4.6c-1.3 0-2.5-1.1-2.5-2.5v-4.5c0-0.5 0.2-0.9 0.7-0.9 0.1 0 0.4 0 0.6 0.2 0.5 0.4 1 0.6 1.7 0.6 1.6 0 2.9-1.6 2.9-3.7s-1.3-3.8-2.9-3.8c-0.5 0-1 0.2-1.4 0.5-0.4 0.3-0.7 0.4-1 0.4-0.4 0-0.6-0.4-0.6-0.8v-3c0-1.3 1.2-2.5 2.5-2.5h4.6c0.7 0 1.3-0.4 0.4-1.5-0.2-0.4-0.4-0.9-0.4-1.4 0-1.6 1.7-2.9 3.8-2.9s3.7 1.3 3.7 2.9c0 0.6-0.2 1.2-0.6 1.7-0.6 0.9 0 1.2 0.6 1.2h4.6c1.4 0 2.5 1.2 2.5 2.5v3c0 0.4-0.2 0.8-0.6 0.8-0.2 0-0.4 0-0.7-0.2-0.4-0.4-1-0.6-1.6-0.6-1.6 0-2.9 1.6-2.9 3.7s1.3 3.8 2.9 3.8c0.5 0 0.9-0.2 1.4-0.5 0.3-0.3 0.7-0.4 0.9-0.4 0.4 0 0.6 0.4 0.6 0.8v4.6z m-21.7-9.6c0.2 0 0.4 0 0.6 0 0.6 0 1.2-0.2 1.8-0.6 0 0 0.1 0 0.1 0 0.1-0.1 0.3-0.2 0.5-0.2 0.5 0 1.2 0.9 1.2 2.1s-0.7 2.1-1.2 2.1c-0.2 0-0.4-0.1-0.6-0.3-0.1 0-0.1-0.1-0.2-0.1-0.5-0.3-1-0.5-1.5-0.5-0.2 0-0.5 0.1-0.7 0.1v-2.6z m21.1 2.6c-0.6 0-1.1 0.2-1.7 0.6-0.1 0-0.1 0-0.2 0-0.1 0.1-0.3 0.2-0.4 0.2-0.6 0-1.3-0.9-1.3-2.1s0.7-2.1 1.3-2.1c0.2 0 0.3 0.1 0.5 0.3 0.1 0 0.2 0.1 0.3 0.1 0.5 0.3 1 0.5 1.5 0.5 0.2 0 0.4-0.1 0.6-0.1v2.6c-0.2 0-0.4 0-0.6 0z m-11.6 9.5c0.2-0.5 0.2-1.3-0.5-2.3 0 0 0-0.1-0.1-0.1-0.1-0.2-0.1-0.3-0.1-0.5 0-0.6 0.9-1.2 2.1-1.2s2 0.6 2 1.2c0 0.2 0 0.4-0.2 0.6-0.1 0-0.1 0.1-0.2 0.2-0.5 0.9-0.5 1.6-0.3 2.1h-2.7z' })
        )
    );
};

exports.default = TiPuzzleOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/puzzle-outline.js
// module id = 1986
// module chunks = 0